// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useMockedUser();

  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },

        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,

          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2, width: '100%' }} />

        <NavSectionMini
          data={navData}
          config={{
            currentRole: user?.role || 'admin',
          }}
        />
        <Stack alignItems="center" spacing={0.5} sx={{ p: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography fontWeight="bold" fontSize="0.5rem">
              Powered By
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.3rem', mt: 1 }}>
              AICTEC &#183; SAUDI ARABIA
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
}
